import React from "react";
import "./plansSection.css";
import { checkOrangeIconRegular, xOrangeIcon } from "../../../utils/icons";

const plans = [
  {
    name: "PLAN STARTER",
    description: "Para explorar la plataforma",
    price: "¡Gratis!",
    period: "",
    features: {
      "Perfil Pro Empresa": true,
      "Recibir CV": false,
      "Notificaciones y Alertas": false,
      "Chat y Mensajeria": false,
      "Anuncios de Trabajos": "1",
      "Explorador de Talentos": false,
      "N° de Usuarios": "1",
      "N° de Ubicaciones": "1"
    }
  },
  {
    name: "PLAN PRO",
    description: "Para más funciones y control",
    price: "$49.900",
    period: "+IVA/mes",
    features: {
      "Perfil Pro Empresa": true,
      "Recibir CV": true,
      "Notificaciones y Alertas": true,
      "Chat y Mensajeria": true,
      "Anuncios de Trabajos": "5",
      "Explorador de Talentos": false,
      "N° de Usuarios": "5",
      "N° de Ubicaciones": "5"
    }
  },
  {
    name: "PLAN PLUS",
    description: "Para gestionar más vacantes",
    price: "$69.900",
    period: "+IVA/mes",
    features: {
      "Perfil Pro Empresa": true,
      "Recibir CV": true,
      "Notificaciones y Alertas": true,
      "Chat y Mensajeria": true,
      "Anuncios de Trabajos": "10",
      "Explorador de Talentos": true,
      "N° de Usuarios": "10",
      "N° de Ubicaciones": "10"
    }
  },
  {
    name: "PLAN PREMIUM",
    description: "Para grandes equipos",
    price: "$99.900",
    period: "+IVA/mes",
    features: {
      "Perfil Pro Empresa": true,
      "Recibir CV": true,
      "Notificaciones y Alertas": true,
      "Chat y Mensajeria": true,
      "Anuncios de Trabajos": "Ilimitados",
      "Explorador de Talentos": true,
      "N° de Usuarios": "Ilimitados",
      "N° de Ubicaciones": "Ilimitados"
    }
  }
];

const featureNames = [
  "Perfil Pro Empresa",
  "Recibir CV", 
  "Notificaciones y Alertas",
  "Chat y Mensajeria",
  "Anuncios de Trabajos",
  "Explorador de Talentos",
  "N° de Usuarios",
  "N° de Ubicaciones"
];

const PlansSection = () => (
  <section className="plans">
    <div className="plans__inner">
      <h2 className="plans__title">Conoce Nuestros Planes</h2>
      <div className="plans__table">
        <div className="plans__header">
          <div className="plans__feature-head">
            <div className="white-rectangle"></div>
            <div>FUNCIONES</div>
          </div>
          {plans.map((plan, i) => (
            <div key={i} className="plans__plan-head">
              <div className="plans__plan-name">{plan.name}</div>
              <div className="plans__plan-description">{plan.description}</div>
            </div>
          ))}
        </div>
        <div className="plans__body">
          {featureNames.map((featureName, i) => (
            <div key={i} className="plans__row">
              <div className="plans__cell plans__feature">{featureName}</div>
              {plans.map((plan, j) => {
                const featureValue = plan.features[featureName];
                return (
                  <div key={j} className="plans__cell">
                    {featureValue === true ? (
                      checkOrangeIconRegular
                    ) : featureValue === false ? (
                      xOrangeIcon
                    ) : (
                      <span className="plans__text">{featureValue}</span>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
          <div className="plans__price-row">
            <div className="plans__price-cell">
              <span className="plans__price-label">{""}</span>
            </div>
            {plans.map((plan, i) => (
              <div key={i} className="plans__price-cell">
                {/* <div className="plans__price-label">{plan.price}</div> */}
                {/* {plan.period && <div className="plans__period">{plan.period}</div>} */}
              </div>
            ))}
          </div>
          <div className="plans__btn-row">
            <div className="plans__btn-cell plans__btn-cell--centered" colSpan="4">
              <button className="plans__btn plans__btn--centered">PRUEBA GRATIS</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default PlansSection;
